module.exports = __webpack_public_path__ + "static/img/misiuk-hojlo-2.2facf3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/misiuk-hojlo-2.png?v=1
// module id = 0hWB
// module chunks = 1